






































import { EventType } from '@/constants';
import { Appointment } from '@/types';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'AppointmentsList',
  components: {
    SortIcon: () => import('./SortIcon.vue'),
    AppointmentListItem: () => import('./AppointmentListItem.vue')
  },
  data () {
    return {
      sortBy: 'Date',
      sortDir: 1,
      sortFields: {
        Type: 0,
        Stage: 0,
        TeamMember: 0,
        Date: 1
      }
    }
  },
  props: {
    appointments: {
      type: Array as PropType<Appointment[]>,
      required: true
    }
  },
  computed: {
    getParams (): any {
      return {
        sort: {
          sortBy: this.sortBy,
          isAscending: !!this.sortDir
        }
      };
    }
  },
  methods: {
    sortData (e: any) {
      if (e.target.id || e.target.parentNode.parentNode.id) {
        const sortingField = e.target.id || e.target.parentNode.parentNode.id;
        this.setSortingParameters(sortingField);
      }
    },
    setSortingParameters (sortingField: string) {
      type sortType = 'Type' | 'Stage' | 'TeamMember' | 'Date';
      this.sortDir = this.sortFields[this.sortBy as sortType] === 0 ? 1 : 0;
      this.sortBy = sortingField;
      this.sortFields[this.sortBy as sortType] = this.sortDir;
      this.$emit(EventType.FETCH_APPOINTMENTS, this.getParams);
    }
  }
});
